<template>
  <div v-if="gcAdsenseModalVisible" class="gc-shared-asense-modal__overlay">
    <div v-click-outside="hideGcAdsenseModal" class="gc-shared-asense-modal__box">
      <img :src="adsModalIllustrationSource" width="200" height="214" class="gc-shared-asense-modal__image">
      <div class="gc-shared-asense-modal__body">GrabCAD Community is home to millions of users and their files.</div>
      <div class="gc-shared-asense-modal__body">With respect, we let you know that this is an ad.</div>
      <div class="gc-shared-asense-modal__body">
        To see fewer ads improve your
        <a
          target="_blank"
          :href="badgesLink"
          >GrabCAD score</a
        >.
      </div>
      <div class="gc-shared-asense-modal__body">
        <button type="button" @click="hideGcAdsenseModal" class="gc-shared-asense-modal__button btn btnRed btnSm">OK, got it</button>
      </div>
      <a :href="discussionLink" target="_parent" class="gc-shared-asense-modal__join-link">Give feedback</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "GcAdsenseModal",
  data() {
    return {
      discussionLink: "/groups/grabcad-community-user-group/discussions/announcement-ads-in-the-grabcad-community",
      badgesLink: Grabcad.site.help_center_badges
    }
  },
  computed: {
    gcAdsenseModalVisible() {
      return Grabcad.communityAdsStore.state.gcAdsenseModalVisible;
    },
    adsModalIllustrationSource() {
      return Grabcad.asense.modal_image;
    }
  },
  methods: {
    hideGcAdsenseModal(event) {
      const ignoreClass = "gc_shared-asense__ignore-target";
      if ([...event.target.classList].includes(ignoreClass)) return;
      if ([...event.target.parentNode.classList].includes(ignoreClass)) return;
      Grabcad.communityAdsStore.commit('hideGcAdsenseModal');
    },
  }
};
</script>
